export default __webpack_public_path__ + "static/sales-tax-4d3f2687ac5ade3b074557b2c9e40d00.jpg";